<!-- eslint-disable vue/no-v-html -->
<template>
    <section class="fac-modal-message" :class="statusClass" :style="$mx_zindex">
        <section class="overlay" />

        <section class="content">
            <section v-if="load" class="box radius">
                <ui-load-indicator
                    v-if="!success"
                    :h="50"
                    :stroke="8"
                    bg-color="#e7e9f4"
                    color="#69D296"
                />
                <span :class="successClass" class="success-icon">
                    <i class="fal fa-check-circle" />
                </span>
            </section>

            <section v-if="error" class="box radius">
                <div class="icon-failed">
                    <span class="danger">
                        <i class="fal fa-times" />
                    </span>
                </div>
            </section>

            <section
                v-if="!load && !error"
                :class="[
                    { 'has-image': image },
                    { 'has-footer': footer },
                    { 'has-icon-circle': iconCircle },
                ]"
                class="box"
            >
                <div v-if="imageComputed" class="box-top-center box-image">
                    <ui-image
                        :src="imageComputed"
                        alt="Modal message image"
                        design="circle border-xl"
                        h="90"
                        w="90"
                    />
                </div>

                <div v-if="iconCircle" :class="colorCircle" class="box-top-center box-icon-circle">
                    <i v-if="icon" class="icon-circle" :class="icon" />
                </div>

                <div v-else-if="icon && !iconCircle" class="icon">
                    <span :class="color"><i :class="icon" /></span>
                </div>

                <div class="message">
                    <div class="title">{{ titleComputed }}</div>
                    <div class="text" v-html="text" />
                    <div v-if="caution" class="caution" v-html="caution" />
                </div>

                <div :class="{ 'footer-circle': iconCircle }" class="footer">
                    <ui-button design="md link" @click="close">Cancelar</ui-button>
                    <ui-button :design="'md ' + btnType" @click="action"> {{ btnText }} </ui-button>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import { uiButton } from '@/components/ui/buttons'
import { uiLoadIndicator, uiImage } from '@/components/ui'

import { modalMixin } from '@/mixins'

export default {
	name: 'ui-modal-message',

	components: { uiButton, uiLoadIndicator, uiImage },

	mixins: [modalMixin],

	props: {
		name: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		caution: {
			type: String,
			required: false,
			default: '',
		},
		text: {
			type: String,
			required: false,
			default: '',
		},
		colorCircle: {
			type: String,
			default: 'primary',
			required: false,
		},
		iconCircle: {
			type: Boolean,
			default: false,
			required: false,
		},
		icon: {
			type: String,
			required: false,
			default: '',
		},
		color: {
			type: String,
			default: '',
		},

		btnType: {
			type: String,
			default: 'success',
		},
		btnText: {
			type: String,
			default: 'Confirmar',
		},
		service: {
			type: String,
			required: false,
			default: '',
		},
		actionSuccess: {
			type: Boolean,
			default: true,
		},
		aboveAll: {
			type: Boolean,
			default: false,
			required: false,
		},
		/**
		 * Usado para mostrar uma imagem no topo do modal
		 */
		image: {
			type: String,
			required: false,
			default: '',
		},
		/**
		 * Usado para mudar o layout do footer
		 * adiciona uma cor clara
		 */
		footer: {
			type: Boolean,
			required: false,
			default: true,
		},

		finallyAction: {
			type: Function,
			default: () => {
				return ''
			},
		},
	},

	data() {
		return {
			data: {
				formdata: {},
				errorTitle: 'Ação não concluída',
				errorText: '',
			},
			status: false,
			load: false,
			success: false,
			error: false,
			api: null,
			getSuccessAction: false,
		}
	},

	computed: {
		statusClass() {
			return this.status ? 'active' : ''
		},
		successClass() {
			return this.success ? 'active' : ''
		},
		loadService() {
			return () => import('@/services/axios/modules/' + this.service + '.js')
		},
		/** Computed property para retornar a imagem configurada no data ou no prop */
		imageComputed() {
			return this.data && this.data.image ? this.data.image : this.image
		},
		titleComputed() {
			return this.data && this.data.title ? this.data.title : this.title
		}
	},

	watch: {
		data(newData){
			this.data = newData				
		}
	},
	
	created(){
		document.addEventListener('keydown', (event) => {
			if(event.key === "Escape") this.close()
		});

		document.addEventListener('keydown', this.setEscape)
	},

	mounted() {
		this.$root.$on("modal-msg-open-"+ this.name, (data) => {
			if(data) this.data = data
			this.open()
		})

		this.$root.$on("modal-msg-close-"+ this.name, (data) => {
			if(data) this.data = data
			this.close()
		})

		this.$root.$on("modal-msg-toggle-"+ this.name, (data) => {
			if(data) this.data = data
			this.toggle()
		})

		if (this.service) {
			this.loadService().then(async (response) => {
				this.api = response.default.build()
			})
		}

		this.setActionSuccess = this.actionSuccess
	},

	beforeDestroy() {
		document.removeEventListener('keydown', this.setEscape)
		this.$root.$off('modal-msg-toggle-' + this.name)
		this.$root.$off('modal-msg-open-' + this.name)
		this.$root.$off('modal-msg-close-' + this.name)
	},

	methods: {
		setEscape(event) {
			if (event.key === 'Escape') this.close()
		},

		close() {
			// Remove o modal da lista de modais
			this.$mx_removeModal(this.name)

			this.status = false
			this.error = false

			if (this.data && this.data.eventClose) this.$root.$emit(this.data.eventClose)
		},

		open() {
			// Adiciona o modal na lista de modais
			this.$mx_setModal({
				name: this.name,
				visible: true,
			})

			this.status = true
		},

		toggle() {
			this.status = !this.status
		},
		/**
		 * Event handler que trata o evento de quando a ação do modal é utilizada
		 */
		action() {
			// Evento necessário para que os modais de confirmação de exclusão funcionem
			this.$emit('action', this.data.formdata)

			if (this.service) {
				this.load = true
				this.api[this.data.method](this.data.url, this.data.id, this.data.formdata)
					.then((response) => {
						if (response.data.status == 'error') {
							this.error = true
							this.$toastr.e(response.data.msg)
							// eslint-disable-next-line vue/no-mutating-props
							this.getSuccessAction = false
							this.load = false
						}
						this.success = this.getSuccessAction
						let t = setTimeout(() => {
							this.success = false
							this.load = false
							this.close()
							this.eventSuccess(response.data, this.data.id)
							clearInterval(t)
						}, 1500)
						if (!this.error) {
							setTimeout(() => {
								this.$root.$emit('modal-return-event-' + this.name)
							}, 2500)
						}
					})
					.catch((error) => {
						this.load = false
						this.error = true
						this.data.errorText = this.data.errorText || error.data ? error.data.msg : error.response.data.msg
					})
					.finally(() => {
						this.finallyAction()
					})
				} else {
					this.$root.$emit('modal-msg-event-' + this.name, { action: true, data: this.data })
					this.close()
				}
			},
			
			eventSuccess(data = null, id = null) {
				let eventName = this.data.eventSuccess || this.name + 'success'
				this.$root.$emit(eventName, data, id)
			}
		},
	}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>